
class PageChallengeStatus {
    id: string = "";
    ownerId: string = "";
    pageChallengeId: string = "";  
    dateCompleted: string = "";
    isCompleted: boolean = false;
}

export {PageChallengeStatus};